import React from 'react';
import {useTheme} from 'styled-components/native';

import {Container, IconItem, IconItem5, IconItemC} from './styles';

interface IIcon {
  name: string;
  color?: string;
  iconColor?: string;
  awesome5?: boolean;
  community?: boolean;
}

export function Icon({name, color, iconColor, awesome5, community}: IIcon) {
  const theme = useTheme();
  return color ? (
    !awesome5 ? (
      !community ? <Container style={{backgroundColor: color}}>
        <IconItem
          name={name}
          style={{color: iconColor ? iconColor : theme.colors.primary}}
        />
      </Container>
      : <Container style={{backgroundColor: color}}>
        <IconItemC
          name={name}
          style={{color: iconColor ? iconColor : theme.colors.primary}}
        />
      </Container>
    ) : (
      <Container style={{backgroundColor: color}}>
        <IconItem5
          name={name}
          style={{color: iconColor ? iconColor : theme.colors.primary}}
        />
      </Container>
    )
  ) : !awesome5 ? (
   !community ?  <Container>
      <IconItem
        name={name}
        style={{color: iconColor ? iconColor : theme.colors.primary}}
      />
    </Container> :  <Container>
      <IconItemC
        name={name}
        style={{color: iconColor ? iconColor : theme.colors.primary}}
      />
    </Container>
  ) : (
    <Container>
      <IconItem5
        name={name}
        style={{color: iconColor ? iconColor : theme.colors.primary}}
      />
    </Container>
  );
}
